<template>
  <div>
    <el-table
      class="mt-4"
      v-if="sizeDataList.length"
      :data="sizeDataList"
    >
      <el-table-column
        v-for="(item, index) in size_columns"
        :label="item.label"
        :prop="item.prop"
        :key="index"
        :width="item.minWidth"
      >
      </el-table-column>
      <el-table-column
        label="Action"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <div class="action">
            <span @click="sizeEditHandler(scope.row)" class="cursor-pointer">
                <img src="../../assets/zipCode/edit@2x.png" class="w-4 mr-4" alt="">
              </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <table-empty v-else></table-empty>
    <!--    删除-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      title="Delete this size pricing"
      :visible.sync="sizeDeleteDialog"
      width="35%"
    >
      <div class="addInner" style="margin-top: 24px">
        <div>
          <el-form
            :model="sizeForm"
            :rules="sizeRules"
            ref="ruleForm"
            label-position="top"
            class="demo-ruleForm login-container"
            :show-message="false"
            status-icon
          >
              <el-form-item prop="cefficient" label="Coefficient" required>
                <el-input
                  v-model="sizeForm.cefficient"
                  auto-complete="off"
                  placeholder="Input a coefficient between 1.00 and 100.00."
                  size="small"
                ></el-input>
              </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button plain style="width: 80px" class="changeFocus"  @click="sizeDeleteDialog = false">Cancel</el-button>
        <el-button type="success" round style="width: 80px;padding: 0"  @click="sizeFirmDelete">Submit</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getSizeCoefficients, saveSizeCoefficient} from "@/api/price";

export default {
  props:{
    selectArea:{}
  },
  data() {
    return {
      sizeDataList: [], // 替换为size开头
      size_columns: [
        {label:"Size",prop:"size",minWidth:260},
        { label: "Coefficient", prop: "coefficient"},
      ], // 原column改为columns
      sizePage: 1, // 页面当前页码
      sizeTotal: 0, // 数据总条数
      sizeDeleteDialog: false, // 控制删除对话框的显示
      deleteSelect: '', // 删除选项选择器的值
      deleteOptions: [ // 删除选项数据
        // 示例数据，具体请按实际情况填写
        { key: 'option1', label: 'Option 1' },
        { key: 'option2', label: 'Option 2' },
      ],
      sizeForm:{
        cefficient:''
      },
      selectSize:'',
      sizeRules:{
        cefficient: [
          { required: true, message: '', trigger: 'blur' }
        ],
      },
    };
  },
  created() {
   this.getSizeCoefficientsHandle()
  },
  methods: {
    getSizeCoefficientsHandle(){
      console.log(this.selectArea,'selectAreazzzzs')
      getSizeCoefficients({
        ma_code:this.selectArea
      }).then(res=>{
        this.$emit('closeLoading')
        this.sizeDataList = res.data?.list
      })
    },
    sizeEditHandler(row) {
      this.selectSize = row.size
      this.sizeForm.cefficient = row.coefficient;
      // 处理编辑逻辑
      this.sizeDeleteDialog = true
    },
    sizeFirmDelete() {
      // 确认编辑逻辑
      // this.$refs.form.clearValidate();
      // this.$refs.form.resetFields();
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          saveSizeCoefficient({
            ma_code:this.selectArea,
            size:this.selectSize,
            coefficient:this.sizeForm.cefficient,
          }).then(res=>{
              if (res.code == 200){
                this.$message({
                  type:"success",
                  message:'successfully edited'
                })
              }
            this.$refs.ruleForm.clearValidate();
            this.$refs.ruleForm.resetFields();
            this.sizeDeleteDialog = false
            this.$emit('updateList')
            this.getSizeCoefficientsHandle()
          })
        }
      })
    },
  },
};
</script>

<style scoped lang="less">

</style>
